import { ConvexProvider, ConvexReactClient } from "convex/react";
import React, { ReactNode } from "react";

// Initialize the Convex client
// Use the production URL from environment variable, with fallback to localhost for development
const convexUrl = import.meta.env.VITE_CONVEX_URL;
const convex = new ConvexReactClient(convexUrl ?? "http://localhost:3001");

// Provider component to wrap your app with Convex
export function ConvexProviderWrapper({ children }: { children: ReactNode }) {
  return React.createElement(ConvexProvider, { client: convex }, children);
}

export default convex;